import { useRef, useEffect } from 'react';
import { getError } from '../../../utils/FormError';
import { useController, useFormContext } from 'react-hook-form';

const InputText = ({
  name,
  placeholder = "",
  validationRules = {},
  onChange,
  autofocus = false,
  disabled = false,
  type = "text",
  autoComplete = "off",
  className,
  style
}) => {
  const inputRef = useRef(null);
  const { control, formState: { errors } } = useFormContext();

  const {
    field: { onChange: rhfOnChange, onBlur, value, ref },
  } = useController({
    name,
    control,
    rules: validationRules,
    defaultValue: '',
  });

  const error = getError(errors, name);

  const handleRef = (el) => {
    inputRef.current = el;
    ref(el);
  };

  useEffect(() => {
    if (autofocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autofocus]);

  const handleChange = (e) => {
    rhfOnChange(e);
    if (onChange) onChange(e);
  };

  return (
    <>
      <input
        type={type}
        name={name}
        id={name}
        autoComplete={autoComplete}
        className={`form-control ${className ?? ''} ${error ? 'is-invalid' : ''}`}
        placeholder={placeholder}
        value={value ?? ''}
        onBlur={onBlur}
        onChange={handleChange}
        ref={handleRef}
        disabled={disabled}
        style={style}
      />
      {error && (
        <div className="invalid-feedback">
          {error.message}
        </div>
      )}
    </>
  );
};

export default InputText;
